import {
  type AdminSearchMyExamRoomRequestInfosQuery,
  ExamLocationRequestWorkflowStepCode,
  type ExamLocationVerdict,
} from '@exam-center/graphql';
import { dayjs } from '@shared/utils';

type ExamRoomRequestInfo =
  AdminSearchMyExamRoomRequestInfosQuery['ecAdminSearchMyExamRoomRequestInfos']['examRoomRequestInfos'][number];

export function mapRejectedExamLocationRequestData(data: ExamRoomRequestInfo) {
  const latestVerdict =
    data.examLocationRequestVerdicts.length > 0
      ? data.examLocationRequestVerdicts.reduce((max, curr) =>
          dayjs(curr.submittedAt).isBefore(dayjs(max.submittedAt)) ? curr : max,
        )
      : null;

  const [firstReviewerVerdict, secondReviewerVerdict]: [
    ExamLocationVerdict | null,
    ExamLocationVerdict | null,
  ] = [
    data.examLocationRequestVerdicts.find(
      (v) =>
        v.step === ExamLocationRequestWorkflowStepCode.ExamLocationRequestInReview_1 &&
        dayjs(v.requestedAt).isSame(dayjs(latestVerdict?.requestedAt)),
    )?.verdict ?? null,
    data.examLocationRequestVerdicts.find(
      (v) =>
        v.step === ExamLocationRequestWorkflowStepCode.ExamLocationRequestInReview_2 &&
        dayjs(v.requestedAt).isSame(dayjs(latestVerdict?.requestedAt)),
    )?.verdict ?? null,
  ];

  return {
    id: data.id,
    refCode: data.taskCode ?? '-',
    buildingName:
      data.examLocationRequestInfo.building?.nameTh ??
      data.examLocationRequestInfo.buildingName ??
      '-',
    locationName: data.examLocationRequestInfo.nameTh ?? '-',
    province: data.examLocationRequestInfo.province.nameTh,
    floor: data.floor,
    roomName: data.name,
    roomNumber: data.roomNumber ?? '-',
    examCenter: data.examCenterCode,
    firstReviewerVerdict,
    secondReviewerVerdict,
    rejectedAt: latestVerdict?.submittedAt ?? null,
    status: 'rejected',
  };
}
